export default {
  props: {
    visitorIndex: {
      type: Number,
      required: true
    },

    visitor: {
      type: Object,
      required: true
    },

    typeaheads: {
      type: Object,
      default: () => {
      }
    }
  },

  computed: {
    inputError () {
      return this.getErrorVisitor(this.visitorIndex, this.inputName)
    },

    hasInputErrors () {
      return this.hasErrorVisitor(this.visitorIndex, this.inputName)
    }
  }
}
